import React from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router';
import Tree from 'containers/tree';
import SearchBarDropDown from 'components/common/searchbardropdown';
import AppHeader from 'components/common/appheader';
export class ToolBar extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            showLocation: false,
            showSetting: false,
            searchActive: false
        };
    }
    closeAll() {
        this.setState({
            showLocation: false,
            showSetting: false
        });
    }


    render() {
        return (
            <AppHeader>
                <div className="header-items">
                    <div className="header-items__location display--flex__flex--start--center">
                        <div onClick={() => { this.setState({ showLocation: true }) }}
                            className="header-btn justify-center cursor--pointer">
                            <span className="font-icon icon-location-hamburger" />
                            <span className="header-btn__label font--bold" >{this.props.tree.info.name}</span>
                        </div>
                        {this.state.showLocation &&
                            <div className="header-items__location__dropdown-root">
                                <div className="location-dropdown-search-container" >
                                    <SearchBarDropDown
                                        querySettings={this.props.querySettings}
                                        onChange={(node) => { this.props.statistic(node); this.closeAll(); }}
                                        onFocus={() => { }}
                                        onClose={() => { }}
                                        tree={this.props.tree}
                                    />
                                </div>
                                <Tree tree={this.props.tree} statistic={(node) => { this.props.statistic(node); this.closeAll(); }} />
                            </div>
                        }
                    </div>

                    <div className="header-items__logo justify-center cursor--pointer">
                        <Link to="/"><img src="src/assets/icons/senzolive-software-logo.svg" alt="SenzoLive" /></Link>
                    </div>

                    <div className="header-items__user-setting overwrite--modal--depth display--flex__flex--end--center">
                        <div onClick={() => { this.setState({ showSetting: true }) }}
                            className="header-btn justify-center cursor--pointer">
                            <span style={{ marginRight: 10 }} className="header-btn__label font--bold">{this.props.user.firstname + " " + this.props.user.lastname}</span>
                            <span className="font-icon icon-user-settings" />
                        </div>
                        <div className={`dropdown-list ${this.state.showSetting ? "dropdown-list_show" : ""}`}>
                            <ul>
                                <li><Link to="/settings/ownaccount" onClick={() => { this.closeAll() }} >Own Account</Link></li>
                                {this.props.user.role == "ADMIN" &&
                                    <li><Link to="/user" onClick={() => { this.closeAll() }} >User Administration</Link></li>
                                }
                                {
                                    (this.props.user.role == "ADMIN") ? [
                                        <li key="0"><Link onClick={() => { this.closeAll() }} to="locations">Locations Settings</Link></li>,
                                        <li key="1"><Link onClick={() => { this.closeAll() }} to="/settings/sensor">Sensor Settings</Link></li>,
                                        <li key="2"><Link onClick={() => { this.closeAll() }} to="/api">SenzoAPI</Link></li>,
                                        <li key="3"><Link onClick={() => { this.closeAll() }} to="/settings/default">Default Settings</Link></li>
                                    ] : null
                                }

                                <li key="4"><Link onClick={() => { this.closeAll() }} to="/livefeed">Livefeed</Link></li>
                                <li><Link onClick={() => { this.closeAll() }} to="/faq">FAQ</Link></li>
                                <li><Link className="cursor--pointer" onClick={this.props.actions.logout}>Log Out</Link></li>
                            </ul>
                        </div>
                        {(this.state.showLocation || this.state.showSetting) &&
                            <div className={"modals__overlay" + ((this.state.showLocation || this.state.showSetting) ? " open" : " closed")} onClick={this.closeAll.bind(this)}></div>
                        }
                    </div>
                </div>
            </AppHeader>


        )
    }
}

function mapStateToProps(state) {
    return {
        user: state.myAccountReducer.user,
        tree: state.overviewReducer.customerOverview,
        cards: state.defaultSettingsReducer.card
    };
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolBar);



// WEBPACK FOOTER //
// ./src/containers/toolbar.jsx